import React, { useEffect } from 'react';

// Components
import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MaskedInput from 'react-text-mask';

// Constants
import { allowancesAmountMask } from '../helpers/textFieldNumberMasks';

// Utilities
import formatCurrency from '../helpers/formatCurrency';

const AmountField = ({
  onChange: upstreamOnChange,
  value,
  updateKey,
  classes = {},
  id,
}) => {
  const onChange = ({ target: { value: rawValue } = {} } = {}) => {
    let value = rawValue;
    if (rawValue === '' || rawValue === 0) value = null;

    upstreamOnChange({
      [updateKey]: value,
    });
  };

  const onBlur = ({ target: { value } = {} } = {}) => {
    if (value === null || value === 0 || value === '') return;

    upstreamOnChange({
      [updateKey]: formatCurrency(value),
    });
  };

  useEffect(() => {
    if (value === 0 || value == null || value === '') return;
    if (formatCurrency(value) === value) return;
    upstreamOnChange({
      [updateKey]: formatCurrency(value),
    });
  }, [value, updateKey, upstreamOnChange]);

  return (
    <TableCell align="center" className={classes.root}>
      <MaskedInput
        mask={allowancesAmountMask}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        render={(ref, props) => (
          <TextField
            inputRef={ref}
            {...props}
            className={classes.textField}
            InputProps={{
              className: classes.textFieldInputContainer,
              inputProps: {
                className: classes.textFieldInput,
                'data-test-id': `AmountField-input-${id}`,
              },
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        )}
      />
    </TableCell>
  );
};

export default AmountField;
